// This file is generated.
export var version = '1.49.2';
//# sourceMappingURL=version.js.map